/* Burga-style client-side filter bar + product grid for the Handyhuellen collection.
 * Fully independent of Dawn's native facets.js / <facet-filters-form> system.
 * Fetches the full product dataset (with metafields) once via the
 * templates/collection.filter-data.liquid JSON feed, then filters/sorts/paginates
 * entirely in the browser. Vanilla JS, no dependencies. */

(function () {
  if (customElements.get('burga-facets')) return;

  var COLOR_HEX = {
    'Schwarz': '#000000',
    'Weiss': '#FFFFFF',
    'Grau': '#9E9E9E',
    'Braun': '#795548',
    'Blau': '#2A5CAA',
    'Grün': '#3E7C4F',
    'Rot': '#C0392B',
    'Rosa': '#F2A7C3',
    'Violett': '#8E6BB5',
    'Gelb': '#F1C40F',
    'Orange': '#E67E22',
    'Mint': '#98D8C8',
    'Mehrfarbig': null,
    'Bambus': '#D8B98A',
    'Nussbaumholz': '#5C4033',
    'Kirschholz': '#7B3F2E',
    'Rosenholz': '#B76E79',
    'Roségold': '#E8B4B8'
  };

  var CASE_TYP_ORDER = ['Eden Case', 'Victor Case', 'Origami', 'Silikon Case'];
  var MOTIV_ORDER = ['FC Basel', 'City', 'Tiere & Natur', 'Kunst', 'Blumen', 'Einfarbig'];
  var PAGE_SIZE = 24;
  var VISIBLE_PILLS = 8;

  // Modell-Werte, die keine echten, im Megamenü geführten Geräte sind (Sammel-/Platzhalterwerte
  // wie "Universal", Mehrfach-Marken-Kombis, oder Marken/Modelle, die aktuell nicht im Megamenü
  // verlinkt sind). Werden aus dem Modell-Filter ausgeblendet; die Produkte selbst sind davon
  // nicht betroffen, sie tauchen weiterhin im Grid auf (nur ohne Modell-Filter-Eintrag).
  var EXCLUDED_MODELS = {
    'Alle Modelle': true,
    'Universal': true,
    'iPhone': true,
    'iPhone / Samsung': true,
    'iPhone und Samsung': true,
    'iPhone, Samsung und Huawei': true,
    'Huawei Mate 20 Pro': true,
    'Huawei P30 Pro': true,
    'Samsung Galaxy Note 10': true,
    'Samsung Galaxy Note 10 Plus': true
  };

  function groupForModel(model) {
    if (/^iPhone/i.test(model)) return 'Apple';
    if (/^Samsung/i.test(model)) return 'Samsung';
    if (/^Huawei/i.test(model)) return 'Huawei';
    return 'Mehrere Modelle / Universal';
  }

  function modelSortKey(model) {
    var m = String(model).match(/\d+/);
    if (m) return parseInt(m[0], 10);
    if (/X/.test(model)) return 10; // iPhone X / XS / XS Max / XR era (no digits in these strings)
    return -1;
  }

  function parsePrice(str) {
    if (!str) return 0;
    var cleaned = String(str).replace(/[^0-9.,]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      cleaned = cleaned.replace(/,/g, '');
    } else if (cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(',', '.');
    }
    var n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function swatchStyle(colorName) {
    var hex = COLOR_HEX[colorName];
    if (colorName === 'Mehrfarbig') {
      return 'background: conic-gradient(red, orange, yellow, green, blue, violet, red);';
    }
    if (!hex) return 'background:#ccc;';
    var border = hex.toUpperCase() === '#FFFFFF' ? 'border:1px solid #ddd;' : '';
    return 'background:' + hex + ';' + border;
  }

  class BurgaFacets extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.collectionUrl = this.getAttribute('data-collection-url') || window.location.pathname;
      this.products = [];
      this.totalPages = 1;

      this.state = {
        model: null,
        caseTyp: null,
        farben: [],
        motiv: [],
        magsafe: false,
        sort: 'relevance',
        page: 1
      };
      this.staged = { farben: [], motiv: [], magsafe: false };
      this.expanded = { farben: false, motiv: false };
      this.modelSearch = '';

      this.readStateFromUrl();
      this.staged.farben = this.state.farben.slice();
      this.staged.motiv = this.state.motiv.slice();
      this.staged.magsafe = this.state.magsafe;

      this.cacheDom();
      this.bindStaticEvents();
      this.loadData();
    }

    cacheDom() {
      this.$count = this.querySelector('[data-role="count"]');
      this.$sortSelect = this.querySelector('[data-role="sort-select"]');
      this.$chips = this.querySelector('[data-role="chips"]');
      this.$grid = this.querySelector('[data-role="grid"]');
      this.$pagination = this.querySelector('[data-role="pagination"]');
      this.$modelList = this.querySelector('[data-role="model-list"]');
      this.$modelSearch = this.querySelector('[data-role="model-search"]');
      this.$caseTypList = this.querySelector('[data-role="case-typ-list"]');
      this.$farbenPills = this.querySelector('[data-role="farben-pills"]');
      this.$motivPills = this.querySelector('[data-role="motiv-pills"]');
      this.$overlay = this.querySelector('[data-role="overlay"]');
    }

    readStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('modell')) this.state.model = params.get('modell');
      if (params.get('casetyp')) this.state.caseTyp = params.get('casetyp');
      if (params.get('farbe')) this.state.farben = params.get('farbe').split(',').filter(Boolean);
      if (params.get('motiv')) this.state.motiv = params.get('motiv').split(',').filter(Boolean);
      if (params.get('magsafe') === '1') this.state.magsafe = true;
      if (params.get('sort')) this.state.sort = params.get('sort');
      if (params.get('page')) this.state.page = parseInt(params.get('page'), 10) || 1;
    }

    writeStateToUrl() {
      var params = new URLSearchParams();
      if (this.state.model) params.set('modell', this.state.model);
      if (this.state.caseTyp) params.set('casetyp', this.state.caseTyp);
      if (this.state.farben.length) params.set('farbe', this.state.farben.join(','));
      if (this.state.motiv.length) params.set('motiv', this.state.motiv.join(','));
      if (this.state.magsafe) params.set('magsafe', '1');
      if (this.state.sort && this.state.sort !== 'relevance') params.set('sort', this.state.sort);
      if (this.state.page && this.state.page > 1) params.set('page', String(this.state.page));
      var qs = params.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '');
      window.history.replaceState(null, '', newUrl);
    }

    bindStaticEvents() {
      var self = this;

      this.querySelectorAll('[data-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.openPanel(btn.getAttribute('data-open'));
        });
      });

      this.querySelectorAll('[data-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closePanel(btn.getAttribute('data-close'));
        });
      });

      this.$overlay.addEventListener('click', function () {
        self.closeAllPanels();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.closeAllPanels();
      });

      if (this.$modelSearch) {
        this.$modelSearch.addEventListener('input', function () {
          self.modelSearch = self.$modelSearch.value.trim().toLowerCase();
          self.renderModelList();
        });
      }

      if (this.$sortSelect) {
        this.$sortSelect.value = this.state.sort;
        this.$sortSelect.addEventListener('change', function () {
          self.state.sort = self.$sortSelect.value;
          self.state.page = 1;
          self.filterAndRender();
        });
      }

      var applyBtn = this.querySelector('[data-role="apply-filters"]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          self.state.farben = self.staged.farben.slice();
          self.state.motiv = self.staged.motiv.slice();
          self.state.magsafe = self.staged.magsafe;
          self.state.page = 1;
          self.closePanel('filter');
          self.filterAndRender();
        });
      }

      var clearAllBtn = this.querySelector('[data-role="clear-all"]');
      if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function () {
          self.state.model = null;
          self.state.caseTyp = null;
          self.state.farben = [];
          self.state.motiv = [];
          self.state.magsafe = false;
          self.staged.farben = [];
          self.staged.motiv = [];
          self.staged.magsafe = false;
          self.state.page = 1;
          self.renderModelList();
          self.renderCaseTypList();
          self.renderFarbenPills();
          self.renderMotivPills();
          self.closeAllPanels();
          self.filterAndRender();
        });
      }

      this.querySelectorAll('[data-more]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-more');
          self.expanded[group] = !self.expanded[group];
          btn.textContent = self.expanded[group] ? 'Weniger anzeigen' : 'Mehr anzeigen';
          if (group === 'farben') self.renderFarbenPills();
          if (group === 'motiv') self.renderMotivPills();
        });
      });

      this.querySelectorAll('[data-stage="magsafe"]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          self.staged.magsafe = !self.staged.magsafe;
          pill.classList.toggle('is-selected', self.staged.magsafe);
        });
      });

      this.$pagination.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-page]');
        if (!btn || btn.disabled) return;
        self.state.page = parseInt(btn.getAttribute('data-page'), 10);
        self.renderGrid();
        self.renderPagination();
        self.writeStateToUrl();
        self.scrollToTop();
      });

      this.$chips.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-chip-remove]');
        if (!btn) return;
        var type = btn.getAttribute('data-chip-remove');
        var value = btn.getAttribute('data-chip-value');
        self.removeFilter(type, value);
      });
    }

    removeFilter(type, value) {
      if (type === 'model') this.state.model = null;
      else if (type === 'caseTyp') this.state.caseTyp = null;
      else if (type === 'farben') {
        this.state.farben = this.state.farben.filter(function (v) { return v !== value; });
        this.staged.farben = this.state.farben.slice();
      } else if (type === 'motiv') {
        this.state.motiv = this.state.motiv.filter(function (v) { return v !== value; });
        this.staged.motiv = this.state.motiv.slice();
      } else if (type === 'magsafe') {
        this.state.magsafe = false;
        this.staged.magsafe = false;
      }
      this.state.page = 1;
      this.renderModelList();
      this.renderCaseTypList();
      this.renderFarbenPills();
      this.renderMotivPills();
      this.filterAndRender();
    }

    openPanel(name) {
      var selector = name === 'case-typ' ? '[data-modal="case-typ"]' : '[data-drawer="' + name + '"]';
      var el = this.querySelector(selector);
      if (!el) return;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      this.classList.add('has-open');
    }

    closePanel(name) {
      var selector = name === 'case-typ' ? '[data-modal="case-typ"]' : '[data-drawer="' + name + '"]';
      var el = this.querySelector(selector);
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (!this.querySelector('.is-open')) this.classList.remove('has-open');
    }

    closeAllPanels() {
      this.querySelectorAll('.burga-drawer.is-open, .burga-modal.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
      });
      this.classList.remove('has-open');
    }

    scrollToTop() {
      var rect = this.getBoundingClientRect();
      if (rect.top < 0) window.scrollTo({ top: window.scrollY + rect.top - 20, behavior: 'smooth' });
    }

    fetchPage(n) {
      // Note: deliberately no Accept: application/json header here — Shopify's storefront
      // routing intercepts that header and serves its built-in generic collection JSON API
      // response instead of our custom `?view=filter-data` alternate Liquid template.
      var url = this.collectionUrl + '?view=filter-data&page=' + n;
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    loadData() {
      var self = this;
      this.$count.textContent = 'Lädt…';
      return this.fetchPage(1)
        .then(function (first) {
          var all = (first.products || []).slice();
          var pages = first.pages || 1;
          self.totalPages = pages;
          if (pages > 1) {
            var rest = [];
            for (var i = 2; i <= pages; i++) rest.push(self.fetchPage(i));
            return Promise.all(rest).then(function (results) {
              results.forEach(function (r) {
                all = all.concat(r.products || []);
              });
              return all;
            });
          }
          return all;
        })
        .then(function (all) {
          self.products = all;
          self.buildFacetOptions();
          self.renderModelList();
          self.renderCaseTypList();
          self.renderFarbenPills();
          self.renderMotivPills();
          self.filterAndRender();
        })
        .catch(function (err) {
          console.error('BurgaFacets: failed to load product feed', err);
          self.$grid.innerHTML = '<div class="burga-empty">Die Produkte konnten nicht geladen werden. Bitte Seite neu laden.</div>';
          self.$count.textContent = '';
        });
    }

    buildFacetOptions() {
      var models = {};
      var farben = {};
      this.products.forEach(function (p) {
        if (p.handymodell && !EXCLUDED_MODELS[p.handymodell]) models[p.handymodell] = true;
        (p.farben || []).forEach(function (f) { farben[f] = true; });
      });
      this.models = Object.keys(models).sort(function (a, b) {
        var diff = modelSortKey(b) - modelSortKey(a);
        if (diff !== 0) return diff;
        return b.localeCompare(a, 'de');
      });
      this.farbenOptions = Object.keys(farben).sort(function (a, b) { return a.localeCompare(b, 'de'); });
    }

    renderModelList() {
      var self = this;
      var GROUP_ORDER = ['Apple', 'Samsung', 'Huawei', 'Mehrere Modelle / Universal'];
      var groups = { 'Apple': [], 'Samsung': [], 'Huawei': [], 'Mehrere Modelle / Universal': [] };
      (this.models || []).forEach(function (m) {
        if (self.modelSearch && m.toLowerCase().indexOf(self.modelSearch) === -1) return;
        groups[groupForModel(m)].push(m);
      });

      var html = '';
      html += '<div class="burga-model-row burga-model-row--all' + (!this.state.model ? ' is-selected' : '') + '" data-model-value="">Alle Modelle' +
        '<span class="burga-model-row__check">✓ Ausgewählt</span></div>';

      GROUP_ORDER.forEach(function (groupName) {
        if (!groups[groupName].length) return;
        html += '<div class="burga-model-group"><h5>' + escapeHtml(groupName) + '</h5>';
        groups[groupName].forEach(function (m) {
          var selected = self.state.model === m;
          html += '<div class="burga-model-row' + (selected ? ' is-selected' : '') + '" data-model-value="' + escapeHtml(m) + '">' +
            escapeHtml(m) + '<span class="burga-model-row__check">✓ Ausgewählt</span></div>';
        });
        html += '</div>';
      });

      if (!html) html = '<div class="burga-empty">Keine Modelle gefunden.</div>';
      this.$modelList.innerHTML = html;

      this.$modelList.querySelectorAll('[data-model-value]').forEach(function (row) {
        row.addEventListener('click', function () {
          var val = row.getAttribute('data-model-value');
          self.state.model = val || null;
          self.state.page = 1;
          self.renderModelList();
          self.filterAndRender();
        });
      });
    }

    renderCaseTypList() {
      var self = this;
      var present = {};
      this.products.forEach(function (p) { if (p.case_typ) present[p.case_typ] = true; });
      var types = CASE_TYP_ORDER.filter(function (t) { return present[t]; });

      var html = '<div class="burga-casetyp-grid">';
      html += '<button type="button" class="burga-casetyp-card burga-casetyp-card--all' + (!this.state.caseTyp ? ' is-selected' : '') + '" data-casetyp-value="">Alle Case-Typen</button>';
      types.forEach(function (t) {
        var selected = self.state.caseTyp === t;
        html += '<button type="button" class="burga-casetyp-card' + (selected ? ' is-selected' : '') + '" data-casetyp-value="' + escapeHtml(t) + '">' +
          '<span class="burga-casetyp-icon">▢</span><span class="burga-casetyp-card__label">' + escapeHtml(t) + '</span></button>';
      });
      html += '</div>';
      this.$caseTypList.innerHTML = html;

      this.$caseTypList.querySelectorAll('[data-casetyp-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-casetyp-value');
          self.state.caseTyp = val || null;
          self.state.page = 1;
          self.renderCaseTypList();
          self.closePanel('case-typ');
          self.filterAndRender();
        });
      });
    }

    renderFarbenPills() {
      var self = this;
      var options = this.farbenOptions || [];
      var visible = this.expanded.farben ? options : options.slice(0, VISIBLE_PILLS);
      var html = '';
      visible.forEach(function (color) {
        var selected = self.staged.farben.indexOf(color) > -1;
        html += '<button type="button" class="burga-pill' + (selected ? ' is-selected' : '') + '" data-stage="farben" data-value="' + escapeHtml(color) + '">' +
          '<span class="burga-pill__dot" style="' + swatchStyle(color) + '"></span>' + escapeHtml(color) + '</button>';
      });
      this.$farbenPills.innerHTML = html || '<div class="burga-empty">Keine Farben verfügbar.</div>';

      var moreBtn = this.querySelector('[data-more="farben"]');
      if (moreBtn) {
        moreBtn.hidden = options.length <= VISIBLE_PILLS;
        moreBtn.textContent = this.expanded.farben ? 'Weniger anzeigen' : 'Mehr anzeigen';
      }

      this.$farbenPills.querySelectorAll('[data-stage="farben"]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-value');
          var idx = self.staged.farben.indexOf(val);
          if (idx > -1) self.staged.farben.splice(idx, 1);
          else self.staged.farben.push(val);
          pill.classList.toggle('is-selected');
        });
      });
    }

    renderMotivPills() {
      var self = this;
      var present = {};
      this.products.forEach(function (p) { if (p.motiv) present[p.motiv] = true; });
      var options = MOTIV_ORDER.filter(function (m) { return present[m]; });
      var visible = this.expanded.motiv ? options : options.slice(0, VISIBLE_PILLS);
      var html = '';
      visible.forEach(function (motiv) {
        var selected = self.staged.motiv.indexOf(motiv) > -1;
        html += '<button type="button" class="burga-pill' + (selected ? ' is-selected' : '') + '" data-stage="motiv" data-value="' + escapeHtml(motiv) + '">' + escapeHtml(motiv) + '</button>';
      });
      this.$motivPills.innerHTML = html || '<div class="burga-empty">Keine Motive verfügbar.</div>';

      var moreBtn = this.querySelector('[data-more="motiv"]');
      if (moreBtn) {
        moreBtn.hidden = options.length <= VISIBLE_PILLS;
        moreBtn.textContent = this.expanded.motiv ? 'Weniger anzeigen' : 'Mehr anzeigen';
      }

      this.$motivPills.querySelectorAll('[data-stage="motiv"]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-value');
          var idx = self.staged.motiv.indexOf(val);
          if (idx > -1) self.staged.motiv.splice(idx, 1);
          else self.staged.motiv.push(val);
          pill.classList.toggle('is-selected');
        });
      });
    }

    filterAndRender() {
      var self = this;
      var filtered = this.products.filter(function (p) {
        if (self.state.model && p.handymodell !== self.state.model) return false;
        if (self.state.caseTyp && p.case_typ !== self.state.caseTyp) return false;
        if (self.state.farben.length) {
          var has = (p.farben || []).some(function (f) { return self.state.farben.indexOf(f) > -1; });
          if (!has) return false;
        }
        if (self.state.motiv.length && self.state.motiv.indexOf(p.motiv) === -1) return false;
        if (self.state.magsafe && !p.magsafe) return false;
        return true;
      });

      if (this.state.sort === 'price-asc') {
        filtered = filtered.slice().sort(function (a, b) { return parsePrice(a.price) - parsePrice(b.price); });
      } else if (this.state.sort === 'price-desc') {
        filtered = filtered.slice().sort(function (a, b) { return parsePrice(b.price) - parsePrice(a.price); });
      } else if (this.state.sort === 'newest') {
        filtered = filtered.slice().sort(function (a, b) { return b.id - a.id; });
      }

      this.filtered = filtered;
      var pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
      if (this.state.page > pages) this.state.page = pages;
      if (this.state.page < 1) this.state.page = 1;

      this.renderCount();
      this.renderGrid();
      this.renderPagination();
      this.renderChips();
      this.writeStateToUrl();
    }

    renderCount() {
      var total = this.filtered.length;
      var totalAll = this.products.length;
      if (total === totalAll) {
        this.$count.textContent = total + ' Produkte';
      } else {
        this.$count.textContent = total + ' von ' + totalAll + ' Produkten';
      }
    }

    renderGrid() {
      var start = (this.state.page - 1) * PAGE_SIZE;
      var pageItems = this.filtered.slice(start, start + PAGE_SIZE);

      if (!pageItems.length) {
        this.$grid.innerHTML = '<div class="burga-empty">Keine Produkte gefunden. Bitte Filter anpassen.</div>';
        return;
      }

      var html = '';
      pageItems.forEach(function (p) {
        html += '<a class="burga-card" href="' + escapeHtml(p.url) + '">' +
          '<div class="burga-card__media">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="400">' : '') +
          '</div>' +
          '<h3 class="burga-card__title">' + escapeHtml(p.title) + '</h3>' +
          '<div class="burga-card__price">' + escapeHtml(p.price) + '</div>' +
          '</a>';
      });
      this.$grid.innerHTML = html;
    }

    renderPagination() {
      var pages = Math.max(1, Math.ceil(this.filtered.length / PAGE_SIZE));
      var current = this.state.page;
      if (pages <= 1) {
        this.$pagination.innerHTML = '';
        return;
      }

      var html = '';
      html += '<button type="button" data-page="' + (current - 1) + '"' + (current <= 1 ? ' disabled' : '') + ' aria-label="Vorherige Seite">‹</button>';

      var pageNums = [];
      for (var i = 1; i <= pages; i++) {
        if (i === 1 || i === pages || Math.abs(i - current) <= 1) pageNums.push(i);
      }
      var last = 0;
      pageNums.forEach(function (n) {
        if (last && n - last > 1) html += '<span>…</span>';
        html += '<button type="button" data-page="' + n + '" class="' + (n === current ? 'is-current' : '') + '">' + n + '</button>';
        last = n;
      });

      html += '<button type="button" data-page="' + (current + 1) + '"' + (current >= pages ? ' disabled' : '') + ' aria-label="Nächste Seite">›</button>';
      this.$pagination.innerHTML = html;
    }

    renderChips() {
      var self = this;
      var chips = [];
      if (this.state.model) chips.push({ type: 'model', label: this.state.model });
      if (this.state.caseTyp) chips.push({ type: 'caseTyp', label: this.state.caseTyp });
      this.state.farben.forEach(function (f) { chips.push({ type: 'farben', label: f, value: f }); });
      this.state.motiv.forEach(function (m) { chips.push({ type: 'motiv', label: m, value: m }); });
      if (this.state.magsafe) chips.push({ type: 'magsafe', label: 'MagSafe-kompatibel' });

      if (!chips.length) {
        this.$chips.innerHTML = '';
        return;
      }

      var html = '';
      chips.forEach(function (c) {
        html += '<span class="burga-chip">' + escapeHtml(c.label) +
          '<button type="button" data-chip-remove="' + c.type + '"' + (c.value ? ' data-chip-value="' + escapeHtml(c.value) + '"' : '') + ' aria-label="Filter entfernen">&times;</button></span>';
      });
      this.$chips.innerHTML = html;
    }
  }

  customElements.define('burga-facets', BurgaFacets);
})();
